import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { defaults, Line } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import BlockUI from '../../component/BlockUI';
import { DateUtil, FormatterUtils, NumberUtils } from '../../utils/javascriptUtils';

// Set Responsive for line chart
defaults.global.maintainAspectRatio = false;

var _ = require('lodash')

function CPUUsageGraph(rrddata_static) {
  
  const data = {
    labels: _.map(rrddata_static, (i) => moment.unix(i.time).format("hh:mm:ss")),
    datasets: [
      {
        label: 'CPU Usage',
        type:'line',
        lineTension: 0.1,
        fill: 'start',
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'red',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: _.map(rrddata_static, (i) => FormatterUtils.round2Decimals(i.cpu * 100)),
        options: {
          maintainAspectRatio : false
        }
      }
    ]
  };
  return (
    <React.Fragment>
      <h3><i className="icon-chip"></i> CPU Usage</h3>
      <article style={{height: "60vh"}} className="canvas-container">
        <Line data={data} height={150} width={500} />
      </article>
    </React.Fragment>
  )
}

function MemoryUsageGraph(rrddata_static) {
  
  const data = {
    labels: _.map(rrddata_static, (i) => moment.unix(i.time).format("hh:mm:ss")),
    datasets: [
      {
        label: 'Total Memory (GB)',
        type:'line',
        lineTension: 0.1,
        fill: "start",
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'red',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: _.map(rrddata_static, (i) => NumberUtils.byteToGb(i.maxmem)),
      },
      {
        label: 'Memory Usage (GB)',
        type:'line',
        data: _.map(rrddata_static, (i) => NumberUtils.byteToGb(i.mem)),
        fill: "start",
        borderColor: '#EC932F',
        backgroundColor: '#EC932F',
        pointBorderColor: '#EC932F',
        pointBackgroundColor: '#EC932F',
        pointHoverBackgroundColor: '#EC932F',
        pointHoverBorderColor: '#EC932F',
      }
    ]
  };
  return (
    <React.Fragment>
      <h3><i className="icon-floppy-disk"></i> Memory Usage</h3>
      <article style={{height: "60vh"}} className="canvas-container">
        <Line data={data} height={150} width={500} />
      </article>
    </React.Fragment>
  )
}

function NetworkTraffic(rrddata_static) {
  
  const data = {
    labels: _.map(rrddata_static, (i) => moment.unix(i.time).format("hh:mm:ss")),
    datasets: [
      {
        label: 'Netin',
        type:'line',
        lineTension: 0.1,
        fill: "start",
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'red',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: _.map(rrddata_static, (i) => FormatterUtils.round2Decimals(i.netin)),
      },
      {
        label: 'Netout',
        type:'line',
        data: _.map(rrddata_static, (i) => FormatterUtils.round2Decimals(i.netout)),
        fill: "start",
        borderColor: '#EC932F',
        backgroundColor: '#EC932F',
        pointBorderColor: '#EC932F',
        pointBackgroundColor: '#EC932F',
        pointHoverBackgroundColor: '#EC932F',
        pointHoverBorderColor: '#EC932F',
      }
    ]
  };
  return (
    <React.Fragment>
      <h3><i className="icon-sphere3"></i> Network Traffic</h3>
      <article style={{height: "60vh"}} className="canvas-container">
        <Line data={data} height={150} width={500} />
      </article>
    </React.Fragment>
  )
}

function DiskIO(rrddata_static) {
  
  const data = {
    labels: _.map(rrddata_static, (i) => moment.unix(i.time).format("hh:mm:ss")),
    datasets: [
      {
        label: 'Disk Read (M)',
        type:'line',
        lineTension: 0.1,
        fill: "start",
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'red',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: _.map(rrddata_static, (i) => FormatterUtils.round2Decimals(i.diskread / 1000000)),
      },
      {
        label: 'Disk Write (K)',
        type:'line',
        data: _.map(rrddata_static, (i) => FormatterUtils.round2Decimals(i.diskwrite / 1000)),
        fill: "start",
        borderColor: '#EC932F',
        backgroundColor: '#EC932F',
        pointBorderColor: '#EC932F',
        pointBackgroundColor: '#EC932F',
        pointHoverBackgroundColor: '#EC932F',
        pointHoverBorderColor: '#EC932F',
      }
    ]
  };
  return (
    <React.Fragment>
      <h3><i className="icon-drive"></i> Disk IO</h3>
      <article style={{height: "60vh"}} className="canvas-container">
        <Line data={data} height={150} width={500} />
      </article>
    </React.Fragment>
  )
}

function ActionButtonGroup(vmData, has_task_running, onVMButtonAction, VpsConsole) {
  return (
    <React.Fragment>
      <center>
        <br/>
        <h3>Actions</h3>
      </center>
      <div style={{justifyContent: "center"}} className="card-body row" >
        <button disabled={has_task_running || vmData.status == "running"} onClick={() => onVMButtonAction("start")} style={{margin: 5, alignItems: "center"}} className="card col-md-1 product-item">
          <i className="icon-play4"></i> 
          Start
        </button>
        <button disabled={has_task_running || vmData.status == "stopped"} onClick={() => onVMButtonAction("shutdown")} style={{margin: 5, alignItems: "center"}} className="card col-md-1 product-item">
          <i className="icon-switch"></i> 
          Shutdown
        </button>
        <button disabled={has_task_running || vmData.status == "stopped"} onClick={() => onVMButtonAction("reboot")} style={{margin: 5, alignItems: "center"}} className="card col-md-1 product-item">
          <i className="icon-sync"></i> 
          Reboot
        </button>
        <button disabled={has_task_running || vmData.status == "stopped"} onClick={() => VpsConsole()} style={{margin: 5, alignItems: "center"}} className="card col-md-1 product-item">
          <i className="icon-browser"></i> 
            Console
        </button>
      </div>
    </React.Fragment>
  )
}

function PercentUsageBar(data) {
    // Thay đổi màu sắc theo phần % CPU và RAM sử dụng.
    const usage_percent_color = (data < 50 && "#4CAF50") || (data > 50 && data < 100 && "orange") || (data > 100 && "red")
    const totalBarCss = {
      minWidth:"150px",
      maxWidth: "200px",
      backgroundColor: "#ddd"
    }
    
    const usageBarCss = {
      width: `${data}%`,
      height: "10px",
      backgroundColor: usage_percent_color,
      textAlign: "center",
      lineHeight: "10px",
      color: "white"
    }
    return (
      <div style={totalBarCss}>
        <div style={usageBarCss}></div>
      </div>
    )
}

function VPSInfoGroup(vmData, userProductData, has_task_running) {

  return (
    <React.Fragment>
      <div style={{border: 'none'}} className="card-body table-responsive">
        <table className="table text-nowrap border">
          <thead> 
            <tr className="table-active">
              <th colSpan="2">Thông tin</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Uptime</td>
              <td>{DateUtil.secondToTime(vmData.uptime)}</td>
            </tr>
            <tr>
              <td>Tên Dịch Vụ</td>
              <td><strong>{userProductData.product.name}</strong></td>
            </tr>
            <tr>
              <td>IP Address</td>
              <td><strong>{userProductData.ip_address}</strong></td>
            </tr>
            <tr>
              <td>Status</td>
              <td className={vmData.status == "running" ? "text-success" : "text-danger"}>
                {!has_task_running ? vmData.status : <img width={30} src="/assets/img/squares.gif" alt="verify"/>}
              </td>
            </tr>
            <tr>
              <td>CPU Usage</td>
              <td>
                {FormatterUtils.round2Decimals(vmData.cpu * 100)}% of {vmData.cpus} CPU(s)
                <br/>
                {PercentUsageBar(FormatterUtils.round2Decimals(vmData.cpu * 100))}
              </td>
            </tr>
            <tr>
              <td>Memory Usage</td>
              <td>
                {NumberUtils.getPercentOfTwoNumber(NumberUtils.byteToGb(vmData.mem), NumberUtils.byteToGb(vmData.maxmem))} %
                ({NumberUtils.byteToGb(vmData.mem)} GiB of {NumberUtils.byteToGb(vmData.maxmem)} GiB) 
                <br/>
                {PercentUsageBar(NumberUtils.getPercentOfTwoNumber(NumberUtils.byteToGb(vmData.mem), NumberUtils.byteToGb(vmData.maxmem)))}
              </td>
            </tr>
            <tr>
              <td>Bootdisk Size</td>
              <td>{NumberUtils.byteToGb(vmData.maxdisk)} GiB</td>
            </tr>
          </tbody>
        </table>
      </div>
    </React.Fragment>
  )
}

function BackupRows(backupData) {
  const inner_tr = _.map(backupData, (i, index) => {
    return (
      <tr key={index}>
        <td>
          {moment(i.backup_date).format("DD-MM-YYYY")}
        </td>
      </tr>
    )  
  })
  return (
    <React.Fragment>
    <div style={{border: 'none', marginLeft: 20}}>
      <h3><i className="icon-database2"></i> Backup List</h3>
    </div>
    <div style={{border: 'none', height: inner_tr.length > 0 ? 200 : null}} className="card-body table-responsive">
      <table className="table text-nowrap border">
        <thead> 
          <tr className="table-active">
            <td>Date</td>
          </tr>
        </thead>
        <tbody>
          {inner_tr}
        </tbody>
      </table>
    </div>
    </React.Fragment>
  )
}

function GraphGroup(rrddata_static) {
  return (
    <div style={{border: "none"}} className="card-body">
      {CPUUsageGraph(rrddata_static)}
      <br/>
      {MemoryUsageGraph(rrddata_static)}
      <br/>
      {NetworkTraffic(rrddata_static)}
      <br/>
      {DiskIO(rrddata_static)}
    </div>
  )
}

class VPSManagePage extends React.Component {
  intervalStatus;
  intervalRRDStatic;
  intervalHAVMStatusLog;
  intervalVmUpidStatus;
  constructor(props) {
    super(props);
    this.state = {
      result_data: [],
      rrddata_static: null,
      vm_data: null,
      user_product_obj: null,
      has_task_running: false,
      action_type: null,
      backup_list: [],
      isLoading: true
    }
  }

  // Thông tin biểu đồ sử dụng các dung lượng của VM
  loadRRDStatic = () => {
    const { user_product_id } = this.props.routeProps.match.params;
    const self = this;
    return axios({
      method: 'get',
      url: window.api_url + '/api/user/vps/rrddata/static/' + user_product_id,
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        self.setState({
          rrddata_static: response.data.data
        })
        self.intervalRRDStatic = setTimeout(self.loadRRDStatic.bind(this), 60000 * 30);
      }
    })
  }

  // Trạng thái của VM.
  loadVMStatus = () => {
    const { user_product_id } = this.props.routeProps.match.params;
    const self = this;
    return axios({
      method: 'get',
      url: window.api_url+ '/api/user/vps/status/' + user_product_id,
      withCredentials: true
    }).then(function (response) {
      self.setState({
        isLoading: false
      })
      if(!response.data.isError) {
        self.setState({
          vm_data: response.data.data
        })
        self.intervalStatus = setTimeout(self.loadVMStatus.bind(this), 15000);
      }
      // Trường hợp VM đã bị PAUSED (SUSPEND) từ kythuat.
      if(response.data.data && response.data.data.status == "paused") {
        clearTimeout(self.intervalStatus);
        clearTimeout(self.intervalRRDStatic);
        clearTimeout(self.intervalHAVMStatusLog);
        clearTimeout(self.intervalVmUpidStatus);
      }
    })
  }

  // Danh sách Task Log (lịch sử tương tác). 
  getTaskRunnning = () => {
    const { user_product_id } = this.props.routeProps.match.params;
    const self = this;
    return axios({
      method: 'get',
      url: window.api_url+ '/api/user/vps/task/running/'+ user_product_id,
      withCredentials: true
    }).then(function (response) {
      // Kiểm tra nếu LOG có task đang running thì phải check UPID của TASK cho đến khi "hoàn thành".
      if(!response.data.isError && response.data.data.task_running) {
        self.setState({
          has_task_running: true
        })
        self.intervalVmUpidStatus = setTimeout(self.vmUpidStatus.bind(self, response.data.data.task_running.upid), 15000);
      } 
    })
  }

  getVMBackupList = () => {
    const { user_product_id } = this.props.routeProps.match.params;
    const self = this;
    return axios({
      method: 'get',
      url: window.api_url+ '/api/user/vps/backup-list/' + user_product_id,
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError && response.data.data) {
        self.setState({
          backup_list: response.data.data
        })
      }
    })
  }

  // Kiểm tra trạng thái VM thông qua UPID.
  vmUpidStatus = (upid) => {
    const { user_product_id } = this.props.routeProps.match.params;
    const self = this;
    this.setState({
      has_task_running: true 
    })
    if(upid) {
      return axios({
        method: 'post',
        url: window.api_url+ '/api/user/vps/upid/status',
        withCredentials: true,
        data: {
          user_product_id: user_product_id,
          upid: upid
        }
      }).then(function (response) {
        // Trường hợp đã hoàn tất Reboot.
        if(!response.data.isError && response.data.data && response.data.data.status == "stopped") {
          self.setState({
            has_task_running: false
          })
        }
      })
    }
  }

  // Kiểm tra trạng thái HA của VM sau khi người dùng click vào các Button
  // Các sự kiện Start và Shutdown cần phả check trạng thái của HA, để chắc rằng các request đã hoàn tất
  checkHAStatus = (action_type = null) => {
    const { user_product_id } = this.props.routeProps.match.params;
    const self = this;
    return axios({
      method: 'get',
      url: window.api_url+ '/api/user/vps/ha/status/' + user_product_id,
      withCredentials: true
    }).then(function (response) {
      const response_data = response.data.data;
      if(action_type && response_data && response_data.state == action_type) {
        self.setState({
          has_task_running: false
        })
      }else if(!action_type && response_data && response_data.request_state == response_data.state) {
        self.setState({
          has_task_running: false
        })
      }else if(response_data && response_data.state == "error") {
        self.setState({
          has_task_running: false
        })
        toast.error("Có lỗi xảy ra, vui lòng thử lại !")
      }else {
        self.setState({
          has_task_running: true
        })
        self.intervalHAVMStatusLog = setTimeout(self.checkHAStatus.bind(this, action_type), 10000);
      }
    })
  }

  VpsConsole = () => {
    const { user_product_id } = this.props.routeProps.match.params;
    const self = this;
    const frameConfig = "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=750,height=450";
    let base_url = null;
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      base_url = "http://localhost:3000";
    } else {
      base_url = "https://id.tadu.cloud";
    }
    return axios({
      method: 'get',
      url: window.api_url+ `/api/user/vps/${user_product_id}/vnc`,
      withCredentials: true
    }).then(function (response) {
      self.setState({
        isLoading: false
      })
      if(!response.data.isError) {
        window.open(`${base_url}/vnc/index.html?path=${response.data.data.token}`, "_blank", frameConfig);
      }
    })
  }

  componentWillUnmount() {
    /*
      stop Load status from continuing to run even
      after unmounting this component. Notice we are calling
      'clearTimeout()` here rather than `clearInterval()` 
    */
   clearTimeout(this.intervalStatus);
   clearTimeout(this.intervalRRDStatic);
   clearTimeout(this.intervalHAVMStatusLog);
   clearTimeout(this.intervalVmUpidStatus);
  }

  onVMButtonAction = (action_type) => {
    const { user_product_id } = this.props.routeProps.match.params;
    const self = this;
    return axios({
      method: 'get',
      url: window.api_url+ '/api/user/vps/task/running/'+ user_product_id,
      withCredentials: true
    }).then(function (response) {
      // Kiểm tra nếu LOG có task đang running thì phải check UPID của TASK cho đến khi "hoàn thành".
      if(!response.data.isError && response.data.data.task_running) {
        self.setState({
          has_task_running: true
        })
        self.intervalVmUpidStatus = setTimeout(self.vmUpidStatus.bind(self, response.data.data.task_running.upid), 15000);
        toast.info("VM trong quá trình thực thi... ")
      }else if(!response.data.isError && !response.data.data.task_running) {
        action_type == "start" && self.onStartVM()
        action_type == "shutdown" && self.onShutdownVM()
        action_type == "reboot" && self.onRebootVM()
      }
    })
  }
  
  // Start Virtual Machine
  onStartVM = () => {
    const { user_product_id } = this.props.routeProps.match.params;
    const self = this;
   
    return axios({
      method: 'post',
      url: window.api_url+ '/api/user/vps/start',
      withCredentials: true,
      data: {
        user_product_id: user_product_id
      }
    }).then(function (response) {
      if(!response.data.isError) {
        self.checkHAStatus("started");
        toast.success("Start VM Thành Công, Vui lòng chờ trong giây lát để hệ thống cập nhật mới trạng thái !")
      }
    })
  }
  
  // Shutdown Virtual Machine
  onShutdownVM = () => {
    const { user_product_id } = this.props.routeProps.match.params;
    const self = this;
    const alert_confirm = window.confirm("Bạn có chắc sẽ Shutdown VPS ?");
    if(alert_confirm) {
      return axios({
        method: 'post',
        url: window.api_url+ '/api/user/vps/shutdown',
        withCredentials: true,
        data: {
          user_product_id: user_product_id
        }
      }).then(function (response) {
        if(!response.data.isError) {
          self.checkHAStatus("stopped");
          toast.success("Shutdown VM Thành Công, Vui lòng chờ trong giây lát để hệ thống cập nhật mới trạng thái !")
        }
      })
    }
  }

  // Reboot Virtual Machine
  onRebootVM = () => {
    const { user_product_id } = this.props.routeProps.match.params;
    const self = this;
    const alert_confirm = window.confirm("Bạn có chắc sẽ Reboot VPS ?");
    
    if(alert_confirm) {
      return axios({
        method: 'post',
        url: window.api_url+ '/api/user/vps/reboot',
        withCredentials: true,
        data: {
          user_product_id: user_product_id
        }
      }).then(function (response) {
        if(!response.data.isError) {
          self.vmUpidStatus(response.data.data);
          toast.success("Reboot VM Thành Công, Vui lòng chờ trong giây lát để hệ thống cập nhật mới trạng thái !")
        }
      })
    }
  }

  // Tìm ra dịch vụ của khách hàng thông qua ID
  getUserProductById() {
    const { user_product_id } = this.props.match.params;
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/api/user/service/'+user_product_id,
      withCredentials: true,
    }).then(function (response) {
      self.loadVMStatus();
      // Dịch vụ phải ở trạng thái "Đang Hoạt Động".
      if(!response.data.isError && response.data.data.status == "RUNNING" ) {
        self.setState({
          user_product_obj: response.data.data
        })
        self.getTaskRunnning();
        self.loadRRDStatic();
        self.checkHAStatus();
        self.getVMBackupList();
      }
    });
  }

  componentDidMount() {
    this.getUserProductById();
  }

  render() {
    const { vm_data, rrddata_static, user_product_obj, backup_list, has_task_running, isLoading } = this.state;
    return(
      <React.Fragment>
        {isLoading && <BlockUI />}
        {!isLoading && <div>
          <ToastContainer />
           {(!vm_data || !user_product_obj) && <div className="card">
             <div className="card-body">
               <span>Dịch vụ không tồn tại !</span>
             </div>
           </div>}
           {(vm_data && vm_data.status == "paused") && <div className="card">
             <div className="card-body">
               <span>Dịch vụ đã bị SUSPEND !</span>
             </div>
           </div>}
           {vm_data && vm_data.status != "paused" && user_product_obj && <div>
             <div className="page-header">
               <div className="page-header-content header-elements-md-inline">
                 <div className="page-title d-flex">
                   <h4>
                     <i className="icon-paragraph-justify2 mr-2"></i>
                     <span className="text-semibold">Quản Lý Cloud Server</span>
                   </h4>
                 </div>
               </div>
             </div>
             <br/>
             <div className="card card-white">
                 {ActionButtonGroup(
                   vm_data,
                   has_task_running,
                   this.onVMButtonAction,
                   this.VpsConsole
                   )}
                 {VPSInfoGroup(vm_data, user_product_obj, has_task_running)}
                 {BackupRows(backup_list)}
                 {GraphGroup(rrddata_static)}
             </div>
           </div>}
        </div>}
      </React.Fragment>
    )
  }
}

const mapState = state => ({

});

const mapDispatch = (dispatch) => ({

});

export default connect(mapState, mapDispatch)(withRouter(VPSManagePage));